module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/tjfx.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Ftjfx.png
// module id = 1PDJ
// module chunks = 93